/**
 * @Author: Zero
 * @Date: 2024-08-26 14:56:32
 * @Explain: 带有拖拽功能的下拉框
 */

import type { ReactNode } from 'react';
import { useMemo } from 'react';
// components
import { Icon } from '@/components/tdesign';
// type
import type { DisplayTextEnum, optsTypes } from './utils/typings';
// utils
import { isArray, isNumber, isString } from '@/utils/common/dataJudgment';
import { selectTreeChildren } from './utils/functions';

type propsType = {
  /** 选中项 */
  selectValue: any;
  /** 重置选中项 */
  resetSelectValue: () => void;
  /** 下拉项内容 */
  dataList: optsTypes[];
  /** 展示类型 */
  renderType: DisplayTextEnum;
  /** placeholder */
  placeholder?: string | ReactNode;
  /** 默认值 */
  defaultValue?: string | number | string[] | number[];
  /** 不展示弹层 */
  onClosePop: () => void;
  /** 自定义显示内容 */
  customRender?: ({
    selectValue,
    selectChildValue,
    selectChildList,
    list,
  }: {
    selectValue: string[];
    selectChildValue?: any[];
    selectChildList?: any[];
    list: optsTypes[];
  }) => ReactNode;
};
const CustomSelect = (props: propsType) => {
  const { selectValue, placeholder, dataList = [], customRender } = props;

  // // 鼠标移入选框范围内
  // const [mouseOverSelect, setMouseOverSelect] = useState(false);
  // // 鼠标移入选框右侧清除按钮范围内
  // const [mouseOverClear, setMouseOverClear] = useState(false);
  // // 鼠标移入list右侧操作区域
  // const [mouseOverListAct, setMouseOverListAct] = useState(false);
  // select内容宽度 - 省略号
  const selectContentWidth = 330;
  // 选中内容文案
  const selectText = useMemo(() => {
    if (customRender) return '';
    let str: any = '';
    if (
      (dataList.length && selectValue && isNumber(selectValue)) ||
      isString(selectValue)
    )
      str = dataList.find((i: any) => i.value === selectValue)?.text;
    if (dataList.length && selectValue && isArray(selectValue)) {
      str = dataList
        .filter((i: any) => selectValue?.includes(i.value))
        .map((i) => i?.text)
        .join();
    }
    return str;
  }, [dataList, selectValue, customRender]);

  return (
    <div
      className="flex-block flex-justify-between select-change-box"
    >
      <div className="flex-block pointer flex-justify-between width-100">
        <div
          className="ellipsis"
          title={
            customRender
              ? selectValue.length > 1
                ? ''
                : customRender?.({
                    selectValue,
                    ...selectTreeChildren({ selectValue, dataList }),
                    list: dataList,
                  })
              : selectText || ''
          }
          style={{ width: selectContentWidth }}
        >
          {customRender?.({
            selectValue,
            ...selectTreeChildren({ selectValue, dataList }),
            list: dataList,
          }) ||
            selectText || <div style={{ color: '#8A949A' }}>{placeholder}</div>}
        </div>
        <Icon.Font name="select-down" />
      </div>
    </div>
  );
};

export default CustomSelect;
